import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import '@mdi/font/css/materialdesignicons.css'

const premiumLight = {
  dark: false,
  colors: {
    background: '#F8F7F5',
    surface: '#FFFFFF',
    primary: '#23372C',
    secondary: '#DFC6AC',
    accent: '#B9975B',
    error: '#8F3A3A',
    info: '#355B7D',
    success: '#2E5A44',
    warning: '#A67B27',
  },
}

const premiumDark = {
  dark: true,
  colors: {
    background: '#111513',
    surface: '#1A211D',
    primary: '#DFC6AC',
    secondary: '#3A4A41',
    accent: '#B9975B',
    error: '#E07A7A',
    info: '#5B8FB9',
    success: '#6AC997',
    warning: '#D6A640',
  },
}

export default createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'premiumLight',
    themes: {
      premiumLight,
      premiumDark,
    },
  },
  defaults: {
    VCard: {
      elevation: 0,
    },
    VBtn: {
      elevation: 0,
    }
  }
})